import UILoader from './Component';

export default UILoader;